import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import ApiService from "../../services/ApiService";
import DateTimeUtils from "../../services/DateTimeUtils";

const CardHistory = ({ basketItem }) => {
    const [courseData, setCourseData] = useState([]);

    useEffect(() => {
        const fetchCourseData = async () => {
            const courseRow = [];

            for (let i = 0; i < basketItem.bookCourses.length; i++) {
                const course = basketItem.bookCourses[i];
                const courseDetails = await ApiService.getCourseById(course.courseId);
                const level = await ApiService.getLevelById(courseDetails.levelCourseId);

                courseRow.push(
                    <div key={course.id} className="card-information">
                        <p className={'mb-0'}>Titolo: {courseDetails.title}</p>
                        <p className={'mb-0'}>Livello corso: {level.level}</p>
                        <p className={'mb-0'}>Inizio corso: {DateTimeUtils.formatCourseStart(courseDetails.start)}</p>
                        {i < basketItem.bookCourses.length - 1 && <hr></hr>}
                    </div>
                );
            }

            setCourseData(courseRow);
        };

        fetchCourseData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [basketItem]);

    return (
        <Row className="card g-0 mb-3">
            <Col xs={12}>
                <div className="card-body">
                    {courseData.length > 0 ? courseData : "Nessun dato disponibile"}
                </div>
            </Col>
        </Row>
    );
};

export default CardHistory;
